import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var LoadingSummaryService = /** @class */ (function () {
    function LoadingSummaryService() {
        this.loading = false;
        this.loadingSummary = new Subject();
        this.loadingSummaryChanged$ = this.loadingSummary.asObservable();
    }
    LoadingSummaryService.prototype.setLoading = function (loading) {
        this.loading = loading;
        this.loadingSummary.next(this.loading);
    };
    LoadingSummaryService.prototype.getLoading = function () {
        return this.loading;
    };
    LoadingSummaryService.prototype.clearLoading = function () {
        this.loading = false;
    };
    LoadingSummaryService.ngInjectableDef = i0.defineInjectable({ factory: function LoadingSummaryService_Factory() { return new LoadingSummaryService(); }, token: LoadingSummaryService, providedIn: "root" });
    return LoadingSummaryService;
}());
export { LoadingSummaryService };
